var map = {
	"./BOU/regular.png": "6b49",
	"./DRU/regular.png": "4e24",
	"./FNB/regular.png": "7c34",
	"./HIM/regular.png": "3962a",
	"./OTH/regular.png": "733d",
	"./SUP/regular.png": "d196"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7fe";